import { useMutation } from '@tanstack/react-query';

import postUserImage from 'Api/brief-live/postUserImage';
import postUserImageRequest from 'Domain/brief-live/model/request/postUserImageRequest';
import postUserImageResponse from 'Domain/brief-live/model/response/postUserImageResponse';

import { useToast } from 'Store/toast';
import useIsMobile from 'Hook/useIsMobile';
import getApiErrorMessage from 'Helper/getApiErrorMessage';

const usePostUserImage = () => {
  const { onOpenToast } = useToast();
  const isMobile = useIsMobile();

  return useMutation({
    mutationFn: async (data) => {
      const payload = await postUserImageRequest(data);

      const response = await postUserImage({ payload });

      const result = postUserImageResponse(response);

      return result;
    },
    onSuccess: async () => {
      onOpenToast({
        description: 'User image uploaded successfully',
        status: 'success',
        duration: 5,
        position: 'top',
        type: isMobile ? 'mobile' : 'desktop',
      });
    },
    onError: async (error) => {
      onOpenToast({
        description: getApiErrorMessage(error?.response?.data?.message),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: isMobile ? 'mobile' : 'desktop',
      });
    },
  });
};

export default usePostUserImage;
